export default "__VITE_ASSET__82db63a7__"